import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {  Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClientService } from './http-client.service';

const baseUrl = environment.hostService + '/Formulas';

@Injectable({
  providedIn: 'root'
})

export class FormulasService {

  constructor(private _http: HttpClientService) { }

  getVariables(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + "/GetVariablesList"});
  }

  getDetail(code): Observable<any> {
    return this._http.get<any>({ url: baseUrl + "/GetVariables/" + code});
  }

  getFormulas(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + "/GetFormulas" });
  }

  getFormulasById(id): Observable<any> {
    return this._http.get<any>({ url: baseUrl + "/GetFormulasById?id=" + id });
  }

  saveFormula(data): Observable<any> {
    return this._http.post<any>({ url: baseUrl + '/SaveFormula', body: data, cacheMins: 0 })
  }

  deleteFormula(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/DeleteFormula?id=' + id });   
  }
}
